import { t } from '@/utils/i18n'
import { constant } from '@/utils'
import styles from './index.module.less'
import iconTruck from '@/assets/img/icon/icon-truck.png'
import iconAir from '@/assets/img/icon/icon-air.png'
import iconShip from '@/assets/img/icon/icon-ship.png'

// 运输方式：0海运 1陆运 2空运
const shippingTypeIconList = [iconShip, iconTruck, iconAir]

const {
  order: { PickType },
} = constant

function PickTypeLabel({
  pickType,
  shippingType,
  className,
  crossBorder = 0,
}: {
  pickType: number | null,
  shippingType: number | null,
  className?: string
  crossBorder: number
}) {
  const pickTypeLabel =
    pickType === null ? '' : pickType === PickType.SELF_PICK ? t('自提') : 'COD'

  const styleList = {
    color: '#ffffff',
    backgroundColor: pickType === PickType.SELF_PICK ? '#4C87FF' : '#26C25F',
  }

  const labelClassNames = `${styles['label-wrap']} ${className ? className : ''}`
  return (
    <>
      {!!pickTypeLabel && (
        <span style={styleList} className={labelClassNames}>
          {pickTypeLabel}
          {(crossBorder === 1 && /\d/.test(String(shippingType))) && (<img src={shippingTypeIconList[shippingType as number]} />)}
        </span>
      )}
    </>
  )
}

export default PickTypeLabel
